import { render, staticRenderFns } from "./SheetQuickActions.vue?vue&type=template&id=fa4b8880&"
import script from "./SheetQuickActions.vue?vue&type=script&lang=js&"
export * from "./SheetQuickActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports